/* eslint-disable import/no-cycle */
import api from './api.service';

function index(params) {
  return api.get('/schools-types/', params);
}

function get(id, params) {
  return api.get(`/schools-types/${id}`, params);
}

function create(params) {
  return api.post('/schools-types', params);
}

function update(id, params) {
  return api.put(`/schools-types/${id}/update`, params);
}

function remove(id, params) {
  return api.delete(`/schools-types/${id}`, params);
}

function save(params) {
  return (params.id) ? update(params.id, params) : create(params);
}

export const schoolsTypesService = {
  index,
  get,
  create,
  update,
  remove,
  save,
};
